import {all, AllEffect, fork, ForkEffect, put, takeEvery} from 'redux-saga/effects';
import {simpleDataProvider} from '../fetchApi';
import {DataProviderActionShape} from '../fetchApi/tsTypes';
import {
    DATA_PROVIDER_ACTION_FAILURE,
    DATA_PROVIDER_ACTION_PREFIX,
    DATA_PROVIDER_ACTION_SUCCESS,
    DATA_PROVIDER_CALL,
} from '../actions/types';
import {logoutUser} from '../actions';

function* processDataProviderAction({payload, meta}: DataProviderActionShape): Generator<any> {
    const {onSuccess, onFailure, resource, fetch: type} = meta;
    try {
        const result: any = yield simpleDataProvider(type, resource, payload);

        yield put({type: `${DATA_PROVIDER_ACTION_PREFIX}/${type}/${DATA_PROVIDER_ACTION_SUCCESS}`});
        onSuccess.callback(result);
    } catch (e) {
        yield put({type: `${DATA_PROVIDER_ACTION_PREFIX}/${type}/${DATA_PROVIDER_ACTION_FAILURE}`, error: e});
        if (e.redirectTo) {
            // @ts-ignore
            yield put(logoutUser(e.redirectTo));
            e = {message: 'Unauthorized', code: 401};
        }

        onFailure.callback(e);
    }
}

function* getDataProviderActions(): Generator<ForkEffect> {
    yield takeEvery([DATA_PROVIDER_CALL], processDataProviderAction);
}

export default function* dataProviderSagas(): Generator<AllEffect<ForkEffect>> {
    yield all([
        fork(getDataProviderActions),
    ]);
}